import styled from "styled-components";

export const MetierDetailsWrapper = styled.div`
  .news-carousel {
    margin-top: 120px;
  }
`;
